define [], () ->
  (stateHelperProvider, WHITE_LABEL) ->
    stateHelperProvider.state
      name: 'root'
      template: require('./index.jade')
      controller: ($state, $scope, hotkeys) ->
        hotkeys.bindTo($scope)
        .add
          combo: 'up up down down left right left right b a enter',
          description: ''
          callback: () -> console.log 'contra code'
      children: [
        if WHITE_LABEL then require("./bare_home/routes.coffee") else require ("./home/routes.coffee")
        require ("./home/routes_alt.coffee")
        require("./dashboard/routes.coffee")
        require("./forms/routes.coffee")
        require("./applications/routes.coffee")
        require("./verifications/routes.coffee")
        require("./payment/routes.coffee")
        require("./view_only/routes.coffee")
      ]



// WEBPACK FOOTER //
// ./components/routes.coffee